export const CloudStorageKeys = {
  CLOSED_STACKS_SUB_POPUPS: 'CLOSED_STACKS_SUB_POPUPS',
  FEED_SEARCH: 'FEED_SEARCH',
  GOOGLE_CALENDAR_ONBOARDING_PASSED: 'GOOGLE_CALENDAR_ONBOARDING_PASSED',
  HIDE_GOOGLE_SETTINGS_TOOLTIP: 'HIDE_GOOGLE_SETTINGS_TOOLTIP',
  HIDE_INVITEE_BANNER: 'HIDE_INVITEE_BANNER',
  HIDE_SLOTS_NEW_LABEL: 'HIDE_SLOTS_NEW_LABEL',
  SHOW_PRO_TOOLTIP: 'SHOW_PRO_TOOLTIP',
  SHOW_SLOTS_READY_BADGE: 'SHOW_SLOTS_READY_BADGE',
  SHOW_WELCOME: 'SHOW_WELCOME',
  THEME_PRESELECT_NOTE_SEEN: 'THEME_PRESELECT_NOTE_SEEN',
  THEME_TOOLTIP_SEEN: 'THEME_TOOLTIP_SEEN',
} as const;
